(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filtered-blog-posts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('filtered-blog-posts')) {
    customElements.define(
      'filtered-blog-posts',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.dataset.blog || this.started) return;

          this.started = true;

          this.querySelector('[data-retry]').onclick = () => {
            this.loadPosts();
          };

          this.loadPosts();
        }

        disconnectedCallback() {
          this.controller?.abort();
          this.started = false;
        }

        async loadPosts() {
          this.controller?.abort();

          const controller = new AbortController();
          this.controller = controller;

          const status = this.querySelector('[data-status]');
          const results = this.querySelector('[data-results]');
          const retry = this.querySelector('[data-retry]');
          const archive = this.querySelector('[data-archive]');

          status.textContent = 'Loading posts…';
          results.setAttribute('aria-busy', 'true');
          retry.hidden = true;

          const timeout = setTimeout(() => {
            controller.abort();
          }, 20000);

          try {
            const url = new URL(
              this.dataset.url,
              window.location.origin
            );

            if (url.origin !== window.location.origin) {
              throw new Error('Invalid origin');
            }

            url.searchParams.set(
              'section_id',
              'filtered-blog-posts'
            );
            url.searchParams.set('page', '1');

            const preview = new URL(
              window.location.href
            ).searchParams.get('preview_theme_id');

            if (preview) {
              url.searchParams.set('preview_theme_id', preview);
            }

            const response = await fetch(url, {
              signal: controller.signal,
              credentials: 'same-origin'
            });

            if (!response.ok) {
              throw new Error('Blog request failed');
            }

            const doc = new DOMParser().parseFromString(
              await response.text(),
              'text/html'
            );

            const payload = doc.querySelector(
              'template[data-fbp-payload]'
            );

            if (
              !payload ||
              payload.dataset.blog !== this.dataset.blog
            ) {
              throw new Error('Unexpected blog response');
            }

            if (controller.signal.aborted || !this.isConnected) {
              return;
            }

            const count = Math.max(
              1,
              Math.min(24, Number(this.dataset.count) || 3)
            );

            const words = Math.max(
              5,
              Math.min(100, Number(this.dataset.words) || 30)
            );

            const fragment = document.createDocumentFragment();

            const cards = Array.from(
              payload.content.querySelectorAll('.fbp__item')
            ).slice(0, count);

            cards.forEach(card => {
              const excerpt = card.querySelector('.fbp__excerpt');
              const text = excerpt.textContent.trim().split(/\s+/);

              excerpt.textContent =
                text.slice(0, words).join(' ') +
                (text.length > words ? '…' : '');

              if (this.dataset.images === 'false') {
                card.querySelector('.fbp__image')?.remove();
              }

              fragment.append(card);
            });

            results.replaceChildren(fragment);

            status.textContent = cards.length
              ? ''
              : 'No posts match this blog and tag.';
          } catch (error) {
            if (
              !this.isConnected ||
              this.controller !== controller
            ) {
              return;
            }

            status.textContent =
              'Posts could not be loaded. Try again or open the blog below.';

            retry.hidden = false;
            archive.hidden = false;
          } finally {
            clearTimeout(timeout);

            if (this.controller === controller) {
              results.removeAttribute('aria-busy');
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
